import { SubmitButton } from '@/components/submit-button';
import { Button } from '@/components/ui/button';
import {
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';

import { useCreateRoleMutation } from '@/query/role.query';

import { RoleCreateForm } from './components/create-form';

import { RoleCreateFormProvider } from '@/formik/role.formik';

type Props = {
  isOpen: boolean;
  toggle: () => void;
};

export const RoleCreate = ({ isOpen, toggle }: Props) => {
  const mutate = useCreateRoleMutation({
    onSuccess: () => {
      toggle();
    },
  });

  return (
    <Dialog open={isOpen} onOpenChange={toggle}>
      <DialogContent className="flex flex-col max-h-[90vh] sm:max-w-2xl">
        <RoleCreateFormProvider onSubmit={mutate.mutate} className="flex flex-col flex-1 min-h-0">
          <DialogHeader className="mb-4 pb-4 border-b">
            <DialogTitle>Add role</DialogTitle>
          </DialogHeader>

          {/* Create Role Form */}
          <div className="overflow-y-auto flex-1 min-h-0 -mx-6 px-6">
            <RoleCreateForm />
          </div>

          <DialogFooter className="mt-4">
            <Button type="button" variant="outline" onClick={toggle} className="flex-1">
              Cancel
            </Button>
            <SubmitButton isPending={mutate.isPending} />
          </DialogFooter>
        </RoleCreateFormProvider>
      </DialogContent>
    </Dialog>
  );
};
